export const colors = [ 'Chocolate', 'Black', 'White', 'Tan', 'Grey', 'Blue' ]

export const patterns = [ 'Solid', 'Brindle', 'Patchy', 'Banded', 'Marbled', 'Flecked' ]

export default {
  colors,
  patterns
}
